export default "__VITE_ASSET__8701bf4b__"